import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import CallToAction from 'components/ProductPage/CallToAction';
import ProductViewsCount from 'components/ProductPage/ProductViewsCount';
import SkeletonBanner from 'components/Banner/SkeletonBanner/SkeletonBanner';
import MediaUtils from 'utils/Media';

const { Media } = MediaUtils;

const CommerceSection = ({
    isSkuReady,
    isSmallView,
    currentProduct,
    callToActionSku,
    basketType,
    sameDayAvailable,
    loveIcon,
    displayQuantityPickerInATB,
    commerce,
    fulfillment,
    showPdpCompare,
    increaseATBButtonOnPdpStyle,
    showSocialProofPDP,
    viewSimilarProductsLink,
    hasConfigurableOptions
}) => {
    const currentSku = currentProduct?.currentSku;

    if (hasConfigurableOptions) {
        return null;
    }

    if (!isSkuReady) {
        return <SkeletonBanner />;
    }

    return (
        <>
            <CallToAction
                viewSimilarProducts={viewSimilarProductsLink}
                isSmallView={isSmallView}
                addToBasketDataAt='add_to_basket_btn'
                addToBasketDataAtSm='add_to_basket_btn_small_view'
                displayQuantityPickerInATB={displayQuantityPickerInATB}
                basketType={basketType}
                isSameDayAvailable={sameDayAvailable && currentSku?.isSameDayEligibleSku}
                sku={callToActionSku}
                product={currentProduct}
                productExtraDetailsLoaded={fulfillment.productExtraDetailsLoaded}
                loveIcon={loveIcon}
                replenishmentFreqNum={commerce.replenishmentFreqNum}
                replenishmentFreqType={commerce.replenishmentFreqType}
                autoReplenishChecked={commerce.autoReplenishChecked}
                autoReplenishQuantity={commerce.quantity}
                onAutoReplenishQuantityChange={value => commerce.setQuantity(Number(value))}
                updateFrequencyModal={commerce.updateFrequencyModal}
                isAutoReplenMostCommon={commerce.isAutoReplenMostCommon}
                isKohlsStore={fulfillment.isKohlsStore}
                showPdpCompare={showPdpCompare}
                increaseATBButtonOnPdpStyle={increaseATBButtonOnPdpStyle}
            />
            {!currentSku?.isOutOfStock && !showSocialProofPDP.challengerOne && !showSocialProofPDP.challengerTwo && (
                <Media greaterThan='sm'>
                    <ProductViewsCount />
                </Media>
            )}
        </>
    );
};

export default wrapFunctionalComponent(CommerceSection, 'CommerceSection');
